var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPng3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66669 46.6667V44.3333C4.66669 35.3127 11.9794 28 21 28V28",
    stroke: "#564418",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8755 28.7315C38.373 27.0871 40.9604 27.0871 42.4579 28.7315V28.7315C43.2147 29.5626 44.3025 30.0131 45.4253 29.9607V29.9607C47.647 29.8568 49.4765 31.6864 49.3727 33.908V33.908C49.3202 35.0308 49.7708 36.1186 50.6018 36.8754V36.8754C52.2462 38.373 52.2462 40.9603 50.6018 42.4578V42.4578C49.7708 43.2147 49.3202 44.3024 49.3727 45.4253V45.4253C49.4765 47.6469 47.647 49.4764 45.4253 49.3726V49.3726C44.3025 49.3201 43.2147 49.7707 42.4579 50.6018V50.6018C40.9604 52.2461 38.373 52.2461 36.8755 50.6018V50.6018C36.1187 49.7707 35.0309 49.3201 33.9081 49.3726V49.3726C31.6864 49.4764 29.8569 47.6469 29.9607 45.4253V45.4253C30.0132 44.3024 29.5626 43.2147 28.7316 42.4578V42.4578C27.0872 40.9603 27.0872 38.373 28.7316 36.8754V36.8754C29.5626 36.1186 30.0132 35.0308 29.9607 33.908V33.908C29.8569 31.6864 31.6864 29.8568 33.9081 29.9607V29.9607C35.0309 30.0131 36.1187 29.5626 36.8755 28.7315V28.7315Z",
    stroke: "#564418",
    strokeWidth: 3.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8485 39.6666L38.394 42.2121L43.4849 37.1212",
    stroke: "#564418",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21 28C26.1547 28 30.3334 23.8214 30.3334 18.6667C30.3334 13.512 26.1547 9.33337 21 9.33337C15.8454 9.33337 11.6667 13.512 11.6667 18.6667C11.6667 23.8214 15.8454 28 21 28Z",
    stroke: "#564418",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPng3);
export default __webpack_public_path__ + "static/media/png3.eae39ba9b8a2cd3fe7bb714f88182354.svg";
export { ForwardRef as ReactComponent };